<template>
  <tr :class="{ 'row-with-error': hasError }">
    <td class="name-cell">
      <div class="position-relative">
        <v-text-field
          :value="row.name"
          dense
          hide-details
          class="name-field"
          :class="{ 'field-error': hasNameError }"
          @input="$emit('update-field', 'name', $event)"
        ></v-text-field>
        <span v-if="hasNameError" class="error-text">
          <v-icon x-small color="error">mdi-alert-circle</v-icon>
          {{ $t("LABELS.REQUIRED") }}
        </span>
      </div>
    </td>

    <td class="code-cell">
      <v-text-field
        :value="row.code"
        dense
        hide-details
        @input="$emit('update-field', 'code', $event)"
      ></v-text-field>
    </td>

    <td class="machine-cell">
      <div class="position-relative">
        <v-autocomplete
          :value="row.machine"
          :items="machines"
          item-text="name"
          return-object
          dense
          hide-details
          clearable
          :class="{ 'is-invalid': hasMachineError }"
          @input="$emit('update-field', 'machine', $event)"
        ></v-autocomplete>
        <span v-if="hasMachineError && hasWarehouseError" class="error-text">
          <v-icon x-small color="error">mdi-alert-circle</v-icon>
          {{ $t("LABELS.MACHINE_OR_WAREHOUSE_REQUIRED") }}
        </span>
      </div>
    </td>

    <td class="warehouse-cell">
      <div class="position-relative">
        <v-autocomplete
          :value="row.serviceWarehouseItemId"
          :items="serviceWarehouseItems"
          item-text="name"
          item-value="id"
          dense
          hide-details
          clearable
          :class="{ 'is-invalid': hasWarehouseError }"
          @input="$emit('update-field', 'serviceWarehouseItemId', $event)"
        ></v-autocomplete>
        <span v-if="hasMachineError && hasWarehouseError" class="error-text">
          <v-icon x-small color="error">mdi-alert-circle</v-icon>
          {{ $t("LABELS.MACHINE_OR_WAREHOUSE_REQUIRED") }}
        </span>
      </div>
    </td>

    <td class="qty-cell">
      <v-text-field
        :value="row.totalQty"
        type="number"
        step="0.01"
        dense
        hide-details
        :class="{ 'field-error': hasQtyError }"
        @input="$emit('update-field', 'totalQty', parseFloat($event) || 0)"
      ></v-text-field>
      <span v-if="hasQtyError" class="error-text">
        <v-icon x-small color="error">mdi-alert-circle</v-icon>
        {{ $t("LABELS.REQUIRED") }}
      </span>
    </td>

    <td class="price-cell">
      <v-text-field
        :value="row.price"
        type="number"
        step="0.01"
        dense
        hide-details
        :class="{ 'field-error': hasPriceError }"
        @input="$emit('update-field', 'price', parseFloat($event) || 0)"
      ></v-text-field>
      <span v-if="hasPriceError" class="error-text">
        <v-icon x-small color="error">mdi-alert-circle</v-icon>
        {{ $t("LABELS.REQUIRED") }}
      </span>
    </td>

    <td class="total-cell">
      <span class="total-price">{{ row.totalPrice }} &euro;</span>
    </td>

    <td class="actions-cell">
      <v-btn icon x-small color="error" @click="$emit('delete')">
        <v-icon small>mdi-delete</v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>
export default {
  name: "ServiceInvoiceRowItem",
  props: {
    row: {
      type: Object,
      required: true
    },
    machines: {
      type: Array,
      default: () => []
    },
    serviceWarehouseItems: {
      type: Array,
      default: () => []
    },
    hasError: {
      type: Boolean,
      default: false
    },
    hasNameError: {
      type: Boolean,
      default: false
    },
    hasPriceError: {
      type: Boolean,
      default: false
    },
    hasQtyError: {
      type: Boolean,
      default: false
    },
    hasMachineError: {
      type: Boolean,
      default: false
    },
    hasWarehouseError: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.name-cell {
  width: 13%;
  padding-left: 24px;
  padding-right: 10px;
}

.code-cell {
  width: 8%;
  padding-right: 10px;
}

.machine-cell,
.warehouse-cell {
  width: 27%;
  padding-right: 10px;
}

.qty-cell {
  width: 3%;
  padding-right: 4px;
}

.price-cell {
  width: 3%;
  padding-right: 4px;
}

.total-cell {
  width: 7%;
  padding-right: 4px;
}

.actions-cell {
  width: 3%;
  text-align: center;
  padding-right: 2px;
}

.name-field {
  min-width: 120px;
  max-width: 100%;
}

.total-price {
  font-weight: 500;
  color: #333;
  display: inline-block;
  padding: 8px 0;
  font-size: 13px;
}

.row-with-error {
  background-color: #fff5f5;
}

.field-error >>> .v-input__control {
  background-color: #ffe2e5 !important;
}

.field-error >>> .v-text-field__slot {
  border-color: #f64e60 !important;
}

.error-text {
  color: #f64e60;
  font-size: 10px;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
}

.position-relative {
  position: relative;
}

.v-text-field,
.v-autocomplete,
.v-input__control,
.v-select__selection,
.v-btn,
td,
th {
  font-size: 13px !important;
}

.v-autocomplete >>> .v-input__icon--clear {
  width: 20px !important;
  height: 20px !important;
  font-size: 16px !important;
}

.v-autocomplete >>> .v-input__icon--clear .v-icon {
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
}

.v-autocomplete >>> .v-input__icon--clear button {
  width: 20px !important;
  height: 20px !important;
}
</style>
